// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v3NF","col":"styles_col__2JQ4T"};